'use strict';

const { conditionIsGo, buildConditionItem, collectConditionFieldIds } = require('./conditionIsGo');

var selectValidateCtrl = ['$state', '$scope', '$uibModal', 'Integration', '$timeout', function ($state, $scope, $uibModal, Integration, $timeout) {
    var _this = this;
    this.loading = true;

    this.printModel = () => {
        console.log('printModel select _this.model', _this.model);
    }

    // Convierte strings de opciones ("valor|etiqueta" / "*|...") al formato {value, name} que usa el template,
    // fijando el valor por defecto cuando la opción incluye "*|".
    this.normalizeOptions = (opts) => {
        return (opts || []).map((option) => {
            if (typeof option === "string") {
                if (option.includes("*|")) {
                    if (_this.model[_this.field.id].value == undefined || _this.model[_this.field.id].value == '')
                        _this.model[_this.field.id].value = option;
                }
                if (option.includes("|")) {
                    const [value, name] = option.split("|").map((str) => str.trim());
                    return { value: option.trim(), name };
                }
                return { value: option.trim(), name: option.trim() };
            }
            return option;
        });
    }

    // Opciones dinámicas (isDinamic): se calculan con el util compartido conditionIsGo, igual que en la app de carga.
    this.applyDynamicOptions = () => {
        const item = buildConditionItem(_this.item && _this.item.payload, _this.model);
        const opts = conditionIsGo(_this.field.templateData.dynamicOptions, item) || [];
        _this.field.templateData.options = _this.normalizeOptions(opts);
        const current = _this.model[_this.field.id] ? _this.model[_this.field.id].value : undefined;
        if (current && !_this.field.templateData.options.some((o) => o.value === current)) {
            _this.model[_this.field.id].value = undefined;
        }
    }

    _this.paramsToRequest = {}; // Parametros para hacer el llamado al back
    _this.paramsIdToWatch = {}; // Id de los otros elementos que afectan al elemento actual y deben observarse.
    // Un select sin integración real (integration.id null) usa opciones estáticas/dinámicas.
    // Chequear el objeto integration no alcanza: puede venir { id: null, dynamicParams: null } y romper más abajo.
    if (!_this.field?.integration?.id) {
        this.loading = false;
        if (_this.field.isDinamic && Array.isArray(_this.field.templateData.dynamicOptions)) {
            _this.applyDynamicOptions();
            const idsToWatch = collectConditionFieldIds(_this.field.templateData.dynamicOptions, []);
            $scope.$watch("ctrl.model", function (newValue, oldValue) {
                if (newValue === oldValue)
                    return;
                const changed = idsToWatch.some((id) => (newValue[id] && newValue[id].value) !== (oldValue[id] && oldValue[id].value));
                if (changed)
                    _this.applyDynamicOptions();
            }, true);
            return;
        }
        if (_this.field.templateData.options.length>0) {
            _this.field.templateData.options = _this.field.templateData.options.map(item => {
                if (typeof item === "string") {
                    if (item.includes("*|")) {
                        if (_this.model[_this.field.id].value == undefined || _this.model[_this.field.id].value == '') {
                            _this.model[_this.field.id].value = item; // set default value '*|'
                        }
                    }
                    // Convert item to object
                    if (item.includes("|")) {
                        const [value, name] = item?.split("|").map(str => str.trim());
                        return { value: item.trim(), name };
                    }
                    return { value: item.trim(), name: item.trim() };
                } else if (typeof item === "object" && item !== null && typeof item.value === 'string') { // when item is already converted to object
                    let value = item.value.trim();
                    if (value.includes("*|") && (!_this.model[_this.field.id]?.value)) {
                        _this.model[_this.field.id].value = value; // set default value '*|'
                    }
                }
                return item;
            });
        }
        return;
    }

    Object.keys(_this.field?.integration?.dynamicParams).forEach(key => {
        _this.paramsToRequest[key] = _this.field?.integration?.defaultParams[key] ?? "";

        const value = _this.field?.integration?.dynamicParams[key];
        _this.paramsIdToWatch[value] = _this.field?.integration?.defaultParams ?? ""; // This params are used to filter fetch data.
    });

    this.reloadParams = function (init = false) {
        Object.keys(_this.paramsToRequest).forEach(key => {
            const fieldId = _this.field?.integration?.dynamicParams[key];
            _this.paramsToRequest[key] = _this.model[fieldId]?.value ?? (_this.item.payload[fieldId]?.value ?? _this.paramsToRequest[key]);
        })
        this.getRequest(_this.paramsToRequest, init)
    }

    this.getRequest = (paramsRef, init) => {
        _this.loading = true;
        Integration.request(
            { integrationId: _this.field.integration.id },
            {
                onlyWS: false,
                params: paramsRef
            }
        ).$promise
        .then((json) => {
            // _this.field.templateData.options = json.response;
            _this.field.templateData.options = json.response.map(item => {
                if (typeof item === "string") {
                    if (init && item.includes("*|")) {
                        if (_this.model[_this.field.id].value == undefined || _this.model[_this.field.id].value == '') {
                            _this.model[_this.field.id].value = item; // set default value '*|' when init
                        }
                    }
                    // Convert item to object
                    if (item.includes("|")) {
                        const [value, name] = item?.split("|").map(str => str.trim());
                        return { value: item.trim(), name };
                    }
                    return { value: item.trim(), name: item.trim() };
                }
                return item;
            });
            _this.loading = false;
        })
        .catch((e) => {
            console.log(e);
            _this.loading = false;
        })
    }

    $scope.$watch("ctrl.model", function (newValue, oldValue) {
        if (newValue === oldValue) 
            return;

        let hasChanges = false;
        Object.keys(newValue).forEach((key) => {
            if (_this.paramsIdToWatch.hasOwnProperty(key)) {
                const newVal = newValue[key]?.value;
                const oldVal = oldValue[key]?.value;

                if (newVal != oldVal) {
                    hasChanges = true;
                }
            }
        });

        if (hasChanges) {
            if (_this.model[_this.field.id] && _this.model[_this.field.id].value !== undefined && _this.model[_this.field.id] && _this.model[_this.field.id].value !== '') {
                _this.model[_this.field.id].value = '';
            } else {
                console.log('La clave o el valor no existen');
            }
            _this.field.templateData.options = []
            _this.reloadParams(true);
        }
    }, true);

    _this.reloadParams(true); // Cuando carga la primera vez el elemento field
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            field: '=',
            model: '=',
            item: '='
        },
        controller: selectValidateCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'directives/selectValidateDirective.html'
    };
};
